import ajax from '../utils/request'

const staticsApi = {
  /***************************金币流水统计管理****************************** */
  // 请求金币流水列表
  getGlodList(params) {
    return ajax({
      url: '/log/gold',
      type: 'get',
      params: params
    })
  },
    // 请求金币流水-用途列表
    getUseList(params) {
      return ajax({
        url: '/log/goldType',
        type: 'get',
        params: params
      })
    },
  /***************************营收数据****************************** */
  getRevenue(params) {
    return ajax({
      url: '/stats/revenue/list',
      type: 'get',
      params: params
    })
  },
  /***************************用户今日统计****************************** */
  getUserTody(params) {
    return ajax({
      url: '/stats/user/daily/list',
      type: 'get',
      params: params
    })
  },
  /***************************提现充值成功统计****************************** */
  getOrderStats(params) {
    return ajax({
      url: '/stats/order/list',
      type: 'get',
      params: params
    })
  },
  /**
   * 获取交易统计里 趋势图详情接口
   * @param {*} params 
   */
  getEchartData(data) {
    return ajax({
      url: '/stats/order/sucRate',
      type: 'post',
      params:data
    })
  },
  /***************************视频收入统计****************************** */
  getVIncomeList(params) {
    return ajax({
      url: '/stats/video/earn/list',
      type: 'get',
      params: params
    })
  },
  /***************************广告点击统计****************************** */
  getClickStatistics(params) {
    return ajax({
      url: '/log/ads/statistical',
      type: 'get',
      params: params
    })
  },
  /***************************视频销售金币统计****************************** */
  getVideoPayGoldStat(params) {
    return ajax({
      url: '/stats/video/earn/aggregate',
      type: 'get',
      params: params
    })
  },
  /***************************视频扣量金币统计****************************** */
  getVideoKlGoldStat(params) {
    return ajax({
      url: '/stats/video/publisher/deduction',
      type: 'get',
      params: params
    })
  },
}

export default staticsApi
